import React from 'react'
import { BookOpen, Plus, Edit, Users } from 'lucide-react'

export function StagesManagement() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Gestion des Stages</h1>
          <p className="text-gray-600">Types d'activités et programmes</p>
        </div>
        <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Plus className="h-4 w-4" />
          <span>Nouveau stage</span>
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6">
          <div className="text-center text-gray-500">
            <BookOpen className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Fonctionnalité à développer</h3>
            <p>La gestion complète des stages sera implémentée ici :</p>
            <ul className="mt-4 text-sm text-left max-w-md mx-auto space-y-2">
              <li>• Création de nouveaux types de stages</li>
              <li>• Configuration des tranches d'âge</li>
              <li>• Définition des tarifs de base</li>
              <li>• Description des activités</li>
              <li>• Images et documentation</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}